<template>
  <v-footer id="footer" padless v-if="loggedIn">
    <v-container id="content-desktop">
      <v-col class="d-flex justify-space-between text-center title" cols="12">
        <p class="font-weight-bold mb-0 pt-0">
          Multicloud Platform version 1.4.0 beta
        </p>
        <div class="d-flex justify-end text-center title">
          <a href="mailto:multicloud@ttpsc.pl">
            <p class="mb-0 pt-0">
              Contact Us
              <v-icon class="ml-1 mr-5 icon" color="#aaa" small
                >fal fa-envelope</v-icon
              >
            </p>
          </a>
          <a :href="`${baseUrl}settings/docs`">
            <p class="mb-0 pt-0">
              Documentation
              <v-icon class="ml-1 icon" color="#aaa" small>fal fa-file</v-icon>
            </p>
          </a>
        </div>
      </v-col>

      <v-col class="text-left copyright mb-0 pt-0">
        <p class="text mb-0 pt-0">
          © Copyright
          <a href="//ttpsc.cloud" target="_blank">PSC</a>
          2021
        </p>
      </v-col>
    </v-container>
  </v-footer>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data: () => ({
    baseUrl: process.env.BASE_URL,
  }),
  computed: mapGetters(["loggedIn"]),
};
</script>

<style scoped>
#footer {
  background: #222129;
  height: auto;
  padding: 8px 0;
  box-shadow: inset 0 5px 6px #000;
  z-index: 9999;
}

#footer span,
p,
a:any-link {
  color: #aaa;
}

#footer > .v-card {
  background: none;
}

.title p,
.copyright {
  font-size: 0.65rem;
  font-family: "Montserrat";
  line-height: 1.4;
}

.icon {
  margin-top: -1px;
}

a {
  text-decoration: none;
  color: #aaa;
}

#footer #content-desktop {
  margin-bottom: 0;
}
</style>
